// The three GHG columns, shared by the Declaration details and Emission calculations tabs.

// The eight components dash out when the RED III default was applied.
export const buildGhgDetailFields = (t, emission) => [
  { label: t('FIELD_DEFAULT_GHG_VALUE_APPLIED'), value: emission.ghgEmissionRed3 },
  { label: t('FIELD_TOTAL_GHG_EMISSIONS'), value: emission.totalGhgEmissions },
  { label: t('FIELD_EEC_EMISSIONS'), value: emission.ghgEec },
  { label: t('FIELD_EL_EMISSIONS'), value: emission.ghgEl },
  { label: t('FIELD_EP_EMISSIONS'), value: emission.ghgEp },
  { label: t('FIELD_ETD_EMISSIONS'), value: emission.ghgEtd },
  { label: t('FIELD_EU_EMISSIONS'), value: emission.ghgEu },
  { label: t('FIELD_ESCA_EMISSIONS'), value: emission.ghgEsca },
  { label: t('FIELD_ECCS_EMISSIONS'), value: emission.ghgEccs },
  { label: t('FIELD_ECCR_EMISSIONS'), value: emission.ghgEccr },
  { label: t('FORM_ALLOCATED_HEAT'), value: emission.allocatedHeat },
  { label: t('FORM_ALLOCATED_ELECTRICITY'), value: emission.allocatedElectricity },
  { label: t('FORM_ESCA_BONUS_CAP'), value: emission.escaBonusCap },
  { label: t('FORM_NUTS2_AREA'), value: emission.nuts2Area },
];

/**
 * The Emission calculations tab's one card.
 *
 * Total spans the row; the eight components pair off two to a row, left column first.
 */
export const buildEmissionCalculationFields = (t, emission) => [
  { label: t('FIELD_TOTAL_GHG_EMISSIONS'), value: emission.totalGhgEmissions },
  [
    { label: t('FIELD_EEC_EMISSIONS'), value: emission.ghgEec },
    { label: t('FIELD_EL_EMISSIONS'), value: emission.ghgEl },
  ],
  [
    { label: t('FIELD_EP_EMISSIONS'), value: emission.ghgEp },
    { label: t('FIELD_ETD_EMISSIONS'), value: emission.ghgEtd },
  ],
  [
    { label: t('FIELD_EU_EMISSIONS'), value: emission.ghgEu },
    { label: t('FIELD_ESCA_EMISSIONS'), value: emission.ghgEsca },
  ],
  [
    { label: t('FIELD_ECCS_EMISSIONS'), value: emission.ghgEccs },
    { label: t('FIELD_ECCR_EMISSIONS'), value: emission.ghgEccr },
  ],
];

export const buildEmissionSavingFields = (t, emission) => [
  { label: t('FIELD_BIOFUELS_TRANSPORT_SAVING'), value: emission.biofuelsForTransport },
  {
    label: t('FIELD_BIOLIQUIDS_ELECTRICITY_SAVING'),
    value: emission.bioliquidsBiomassFuelsElectricity,
  },
  {
    label: t('FIELD_BIOMASS_OUTERMOST_REGIONS_SAVING'),
    value: emission.biomassFuelsElectricityOutermostRegions,
  },
  { label: t('FIELD_BIOLIQUIDS_HEAT_SAVING'), value: emission.bioliquidsBiomassFuelsUsefulHeat },
  {
    label: t('FIELD_BIOMASS_COAL_SUBSTITUTION_SAVING'),
    value: emission.biomassFuelsUsefulHeatCoalSubstitution,
  },
];

export const buildVoluntaryAddOnFields = (t, emission) => [
  { label: t('FORM_FOOD_SECURITY_STANDARD'), value: emission.fssFoodSecurityStandard },
  { label: t('FORM_EU_DEFORESTATION_REGULATION'), value: emission.eudrDeforestationRegulation },
  { label: t('FORM_NON_GMO_FOOD_FEED'), value: emission.nonGmoFoodFeed },
  { label: t('FORM_NON_GMO_TECHNICAL_MARKETS'), value: emission.nonGmoTechnicalMarkets },
];
